type AbbreviationsProps = {
  definitions: { key: string; definition: string }[];
};

const Abbreviations = ({ definitions }: AbbreviationsProps) => {
  return (
    <div className="mt-4 max-w-xl rounded border bg-white p-4 shadow-md">
      <h2 className="mb-2 text-xl font-semibold">Abbreviations Dictionary</h2>
      <div className="h-96 overflow-y-auto border-t border-gray-200 pt-2">
        {definitions.map((item, index) => (
          <div key={index} className="mb-4">
            <p className="font-medium text-gray-800">{item.key}</p>
            <p className="text-sm text-gray-600">{item.definition}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Abbreviations;
